import { Component } from '@angular/core';
import { AuthService, BreadcrumbService, StateService, ThemeService, Utils } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ListThemesRequest, ListThemesResponse, SituViewWebApiClient, Theme } from 'situview-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'themes-list',
  templateUrl: './themes-list.component.html',
  styleUrls: ['./themes-list.component.scss']
})

export class ThemesListComponent extends SituBaseComponent {
  /* Search */
  searchTerm = "";

  orderSelection: string = "name|asc"

  /* Data */
  dataSource = new Array<Theme>();
  filteredDataSource = new Array<Theme>();

  calculateThemeCompletion = false;

  /* Query Parameters */
  readonly FilterParamName: string = "filter";

  /* Loading */
  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewWebApiClient: SituViewWebApiClient,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private snackBar: MatSnackBar,
    private themeService: ThemeService) {
    super(authService, stateService);
    if (this.route.snapshot.queryParams[this.FilterParamName]) {
      this.searchTerm = this.route.snapshot.queryParams[this.FilterParamName];
    }
  }

  protected onSelectedCompanyChange(): void {
    this.loadThemes();
  }

  onCreate() {
    this.router.navigate([`/homes/themes/add`]);
  }

  onCopy() {
    this.router.navigate([`/homes/themes/copy`]);
  }

  
  orderChanged(): void {
    this.sort();
  }

  sort(): void {
    var split = this.orderSelection.split('|');
    var property = split[0] as keyof Theme;
    var ascending = split[1] === 'asc';
    Utils.dynamicSort(this.filteredDataSource, property, ascending);
  }

  filterThemes() {
    if (this.searchTerm) {
      this.filteredDataSource = this.dataSource.filter(theme =>
        (theme.name?.toLowerCase() ?? "").includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.filteredDataSource = this.dataSource;
    }

    this.sort();

    this.updateParams();
  }

  loadCompletionStatus(){
    if (this.calculateThemeCompletion){
      return;
    }

    this.calculateThemeCompletion = true;
    this.loadThemes();
  }

  loadThemes() {
    this.loading = true;

    return this.themeService.LoadThemes(this.selectedCompany?.id!, this.calculateThemeCompletion)
      .then((themes: Theme[]) => {
        this.dataSource = themes;
        this.filterThemes();
      })
      .catch((error: any) => {
        this.showMessage("There was an issue loading themes. Please refresh the page to try again.");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateParams() {
    const queryParams: { [key: string]: any } = {};

    if (this.searchTerm) {
      queryParams.filter = this.searchTerm;
    }
    
    const urlTree = this.router.createUrlTree([], {
      queryParamsHandling: "merge",
      preserveFragment: true,
      queryParams: queryParams
    });

    if (!this.searchTerm) {
      delete urlTree.queryParams[this.FilterParamName];
    }
  
    this.router.navigateByUrl(urlTree);
  }

  timeAgoString(date?: Date): string {
    return Utils.timeAgoString(date);
  }

  pluralize(unit: string, value: number): string {
    return Utils.pluralize(unit, value);
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }
}
